import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./View/Home";
import Contact from "./View/Contact";
import ReqDemo from "./View/ReqDemo";
import WiserAdviser from "./View/WiserAdviser";
import Careers from "./View/Career";
import CareerDetails from "./View/CareerDetails";
import ScrollToTopOnMount from "./ScrollToTopOnMount"
import News from "./View/News";
import PrivacyPolicy from "./View/privacy-policy";
import SecurityProtection from "./View/security-protection";
import Gdpr from "./View/gdpr";
import CookiePolicy from "./View/cookie-policy";
import Global from "./View/Globel";

const AppRoute = () => {
  return (
    <>
      <ScrollToTopOnMount />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/req-demo" element={<ReqDemo />} />
        <Route path="/wiser-adviser" element={<WiserAdviser />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/career-details" element={<CareerDetails />} />
        <Route path="/news" element={<News />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/security" element={<SecurityProtection />} />
        <Route path="/legal/gdpr" element={<Gdpr />} />
        <Route path="/legal/cookies-policy" element={<CookiePolicy />} />
        <Route path="/our-global-network" element={<Global />} />
      </Routes>
    </>
  );
};

export default AppRoute;